/**
 * Destinos do hub visual da homepage (abaixo da Powerpedia).
 * Troque cada `href: '#'` pela rota definitiva quando a página existir.
 */
import { MOCK_ACES } from '@/lib/aces-data';
import { getGuideHref } from '@/lib/guide-routes';

export type HomeExploreHubCardId =
  | 'combo'
  | 'bot'
  | 'aces'
  | 'erros'
  | 'tickets'
  | 'fairtrade';

export type HomeExploreHubCard = {
  id: HomeExploreHubCardId;
  title: string;
  description: string;
  /** Placeholder `#` até existir a página. */
  href: string;
  cta: string;
  /** Smilies gs.xatblog usados na composição do card. */
  smilies: string[];
};

/** Smilie principal de cada Ace (ordem do catálogo). */
export const HOME_EXPLORE_ACE_SMILIES = MOCK_ACES.map((ace) => ace.smileyCode);

export const HOME_EXPLORE_HUB_CARDS: HomeExploreHubCard[] = [
  {
    id: 'combo',
    title: 'Crie seu próprio combo',
    description:
      'Crie combinações únicas de smilies usando nossa biblioteca e dê seu próprio estilo às mensagens.',
    href: '#',
    cta: 'Em breve',
    smilies: ['smile#r', 'cool#g', 'wink#b', 'biggrin#y', 'tongue#m'],
  },
  {
    id: 'bot',
    title: 'Tem um bot pra isso!',
    description: 'Turbine seu chat com um bot e veja tudo o que eles podem fazer.',
    href: '/powers/bot',
    cta: 'Explorar',
    smilies: [],
  },
  {
    id: 'aces',
    title: 'Aces',
    description: 'Entenda como funcionam os Aces e descubra benefícios exclusivos.',
    href: '/aces',
    cta: 'Explorar',
    smilies: HOME_EXPLORE_ACE_SMILIES,
  },
  {
    id: 'erros',
    title: 'Deu ruim?',
    description: 'Encontre explicações para erros comuns e veja como resolver os principais problemas do xat.',
    href: getGuideHref('troubleshooting', 'erros-do-xat'),
    cta: 'Explorar',
    smilies: [],
  },
  {
    id: 'tickets',
    title: 'Bora resolver isso?',
    description:
      'Encontre o caminho certo para falar com o suporte e resolver questões mais específicas.',
    href: getGuideHref('troubleshooting', 'sistema-de-tickets-do-xat'),
    cta: 'Explorar',
    smilies: ['bugou'],
  },
  {
    id: 'fairtrade',
    title: 'Guia de Preços',
    description: 'Valores de referência, histórico e informações para entender melhor o mercado de powers.',
    href: '/fairtrade',
    cta: 'Explorar',
    smilies: [],
  },
];
